(() => {
  const mobile = window.matchMedia('(max-width: 749px)');

  const init = (root = document) => {
    root.querySelectorAll('[data-naru-product-section]').forEach((section) => {
      const sticky = section.querySelector('[data-naru-product-sticky]');
      const purchaseArea = section.querySelector('.naru-product__payment')
        || section.querySelector('.naru-product__buy-row');
      if (!sticky || !purchaseArea || sticky.dataset.naruTriggerBound === 'true') return;

      sticky.dataset.naruTriggerBound = 'true';
      let frame = 0;

      const update = () => {
        frame = 0;
        const delay = Math.min(120, window.innerHeight * 0.12);
        const purchasePassed = purchaseArea.getBoundingClientRect().bottom < -delay;
        const footer = document.querySelector('.naru-footer');
        const footerVisible = footer && footer.getBoundingClientRect().top < window.innerHeight;
        sticky.classList.toggle('is-visible', mobile.matches && purchasePassed && !footerVisible);
      };

      const schedule = () => {
        if (!frame) frame = window.requestAnimationFrame(update);
      };

      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      mobile.addEventListener?.('change', schedule);
      update();
    });
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
